import { bookingFailedEpic } from 'epic/workspace/ordersBasket/orderOperations/requestForBook/bookingFailedEpic';
import { combineEpics } from 'redux-observable';

import { withAppCrashIfException } from '../../index';
import { ordersBasketFormDeletionRequestedEpic } from './formOperations/deleteForm/ordersBasketDeleteFormEpics';
import {
  addToOrdersBasketEpic,
  newOrdersBasketFormRequestedEpic,
  ordersBasketImportRequestedEpic,
  ordersBasketInitFormRequestedEpic,
} from './formOperations/initializeForm/ordersBasketInitializeFormEpics';
import { ordersBasketFormUpdateRequestedEpic } from './formOperations/updateForm/updateFormEpics';
import { bookingResultsEpic } from './orderOperations/requestForBook/bookingResultsEpic';
import { quoteResultReceivedForBookingEpic } from './orderOperations/requestForBook/quoteResultReceivedEpic';
import { requestBookingEpic } from './orderOperations/requestForBook/requestBookingEpic';
import { tradeAuthorizationForBookingEpic } from './orderOperations/requestForBook/tradeAuthorizationEpic';
import { tradeResultReceivedForBookingEpic } from './orderOperations/requestForBook/tradeResultReceivedEpic';
import { cancelQuoteEpic } from './orderOperations/requestForQuoteAndExecute/cancelQuoteEpics';
import { ordersBasketFormExecutionEpic } from './orderOperations/requestForQuoteAndExecute/executeFormEpics';
import { tradeAuthorizationEpic } from './orderOperations/requestForQuoteAndExecute/tradeAuthorizationEpic';
import {
  fetchOrdersBasketTabsEpic,
  fetchOrdersBasketWorkspaceTabsEpic,
  ordersBasketFormMetadataPersistenceRequestedEpic,
  ordersBasketFormMetadataRemovalRequestedEpic,
  ordersBasketPersistedFormFetchRequestedEpic,
  ordersBasketTabContentFetchRequestedEpic,
  ordersBasketTabContentPersistenceRequestedEpic,
} from './persistence/ordersBasketPersistenceEpics';

export const ordersBasketEpic = () =>
  withAppCrashIfException(
    'ordersBasket',
    combineEpics(
      newOrdersBasketFormRequestedEpic(),
      ordersBasketFormDeletionRequestedEpic(),
      ordersBasketFormUpdateRequestedEpic(),
      ordersBasketFormExecutionEpic.priceFormEpic(),
      ordersBasketFormExecutionEpic.executeFormEpic(),
      ordersBasketFormExecutionEpic.quoteResultReceivedEpic(),
      ordersBasketFormExecutionEpic.tradeResultReceivedEpic(),
      ordersBasketImportRequestedEpic(),
      fetchOrdersBasketTabsEpic(),
      fetchOrdersBasketWorkspaceTabsEpic(),
      ordersBasketTabContentPersistenceRequestedEpic(),
      ordersBasketTabContentFetchRequestedEpic(),
      ordersBasketFormMetadataPersistenceRequestedEpic(),
      ordersBasketFormMetadataRemovalRequestedEpic(),
      ordersBasketPersistedFormFetchRequestedEpic(),
      addToOrdersBasketEpic(),
      tradeAuthorizationEpic(),
      cancelQuoteEpic(),
      ordersBasketInitFormRequestedEpic(),
      requestBookingEpic(),
      quoteResultReceivedForBookingEpic(),
      bookingResultsEpic(),
      tradeAuthorizationForBookingEpic(),
      tradeResultReceivedForBookingEpic(),
      bookingFailedEpic(),
    ),
  );
